"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductImage = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _internal = require("../../hooks/internal");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductImage = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    palette
  } = (0, _mui.useTheme)();
  const {
    code,
    image,
    imageAlt,
    lowerImageOpacity,
    name
  } = (0, _internal.useProduct)();
  if (!image) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.ImagePlaceholder, {
      testId: `${getTestId(_constants.ALT_IMG)}-${code}`
    });
  }
  const imagesVariants = {
    url: image,
    backgroundColor: palette.grey[100],
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: 300,
      height: 300,
      quality: 90
    }]
  };
  const images = (0, _imageSizesHelper.getImageVariants)(imagesVariants);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageRoot, {
    alt: imageAlt ?? name,
    className: "imageZoom",
    "data-testid": `${getTestId(_constants.IMG)}-${code}`,
    loading: "lazy",
    lowerImageOpacity: lowerImageOpacity,
    sizes: "300px",
    src: images.at(-1)?.url,
    srcSet: (0, _imageSizesHelper.generateSrcSet)(images)
  });
};
exports.ProductImage = ProductImage;
